const connect = {
  state: {
    canCall: false,
    connectPopoutOpen: false,
    connectDetails: {
      phone: '',
      guid: '',
      readingId: '',
      deviceId: '',
    },
  },
  reducers: {
    setConnectCanCall: (state, payload) => ({
      ...state,
      canCall: payload,
    }),
    setConnectPopoutOpen: (state, payload) => ({
      ...state,
      connectPopoutOpen: payload,
    }),
    setConnectDetails: (state, payload) => ({
      ...state,
      connectDetails: payload,
    }),
    setWsClient: (state, payload) => ({
      ...state,
      wsClient: payload,
    }),
  },
  effects: (dispatch) => ({
    handleConnectPopoutOpen(status) {
      dispatch.connect.setConnectPopoutOpen(status);
    },
    connectDetails(details) {
      dispatch.connect.setConnectDetails(details);
    },
  }),
};

export default connect;
